export { SentimentSuccessIcon } from './sentiment-success-icon';
